import React from 'react';
import { CreditCard, Inbox, TrendingUp, MapPin, Sparkles, Calendar, CheckCircle, Clock, ArrowRight, ChevronRight } from 'lucide-react';
import { MobileLayout } from '../components/MobileLayout';
import { Link } from 'react-router-dom';
export function DashboardPage() {
  // Mock data for upcoming interventions
  const upcomingInterventions = [{
    id: 1,
    zone: 'Milano - Navigli',
    dayAbbr: 'Lun',
    dayNum: '22',
    month: 'Gen',
    time: '10:00 - 15:00',
    serviceType: 'Pulizia standard',
    credits: 15
  }, {
    id: 2,
    zone: 'Milano - Centro',
    dayAbbr: 'Mar',
    dayNum: '23',
    month: 'Gen',
    time: '11:00 - 14:00',
    serviceType: 'Pulizia profonda',
    credits: 12
  }, {
    id: 3,
    zone: 'Milano - Porta Romana',
    dayAbbr: 'Mer',
    dayNum: '24',
    month: 'Gen',
    time: '09:00 - 12:00',
    serviceType: 'Pulizia standard',
    credits: 10
  }];
  return <MobileLayout data-id="element-611">
      {/* Header Section */}
      <div className="mb-6 lg:mb-8" data-id="element-612">
        <h1 className="text-xl lg:text-2xl font-montserrat font-bold text-navy" data-id="element-613">
          Ciao Pulizie Express 👋
        </h1>
        <p className="text-xs lg:text-sm text-gray-500 mt-1" data-id="element-614">
          Gestisci le tue richieste CleanAI
        </p>
      </div>

      {/* CREDIT BALANCE WIDGET - Host compact style */}
      <div className="mb-6 bg-white border border-gray-200 rounded-xl p-4" data-id="element-615">
        <div className="flex items-center gap-2 mb-3" data-id="element-616">
          <CreditCard size={14} className="text-gray-400" data-id="element-617" />
          <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-618">
            Crediti disponibili
          </span>
        </div>
        <div className="flex items-center justify-between" data-id="element-619">
          <div className="flex items-baseline gap-2" data-id="element-620">
            <span className="text-2xl font-semibold text-black" data-id="element-621">42</span>
            <span className="text-sm text-gray-500" data-id="element-622">crediti</span>
          </div>
        </div>
        <div className="text-xs text-gray-400 mt-1 mb-3" data-id="element-623">
          Ultimo acquisto: 15 Gen 2024
        </div>
        <Link to="/crediti" className="text-sm text-teal-deep hover:text-teal-800 font-medium inline-flex items-center gap-1" data-id="element-624">
          Acquista pacchetti <ArrowRight size={14} data-id="element-625" />
        </Link>
      </div>

      {/* QUICK STATS - Host responsive grid */}
      <div className="mb-6 grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-626">
        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-627">
          <div className="flex items-center gap-2 mb-2" data-id="element-628">
            <Calendar size={14} className="text-gray-400" data-id="element-629" />
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-630">
              Questa settimana
            </span>
          </div>
          <div className="text-lg font-semibold text-navy" data-id="element-631">5 interventi</div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-632">
          <div className="flex items-center gap-2 mb-2" data-id="element-633">
            <CheckCircle size={14} className="text-gray-400" data-id="element-634" />
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-635">
              Completati
            </span>
          </div>
          <div className="text-lg font-semibold text-navy" data-id="element-636">23 interventi</div>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-637">
          <div className="flex items-center gap-2 mb-2" data-id="element-638">
            <TrendingUp size={14} className="text-gray-400" data-id="element-639" />
            <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-640">
              Guadagni potenziali
            </span>
          </div>
          <div className="text-lg font-semibold text-navy" data-id="element-641">€1.250</div>
        </div>
      </div>

      {/* PROSSIMI INTERVENTI WIDGET - Calendar icon style */}
      <div className="mb-6 bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-642">
        <div className="p-4 border-b border-gray-100" data-id="element-643">
          <div className="flex items-center justify-between" data-id="element-644">
            <div className="flex items-center gap-2" data-id="element-645">
              <Calendar size={14} className="text-gray-400" data-id="element-646" />
              <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-647">
                Prossimi interventi
              </span>
            </div>
            <Link to="/calendario" className="text-xs text-teal-deep hover:text-teal-800 font-medium inline-flex items-center gap-1" data-id="element-648">
              Vedi tutti <ChevronRight size={14} data-id="element-649" />
            </Link>
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-650">
          {upcomingInterventions.map(intervention => <Link key={intervention.id} to={`/intervento/${intervention.id}`} className="flex items-center gap-4 p-4 hover:bg-gray-50 transition-colors" data-id="element-651">
              {/* Calendar Date Block - White bg, gray border, black text */}
              <div className="flex-shrink-0 w-14 h-14 bg-white border border-gray-200 rounded-xl flex flex-col items-center justify-center" data-id="element-652">
                <span className="text-[10px] font-semibold text-gray-500 uppercase" data-id="element-653">
                  {intervention.dayAbbr}
                </span>
                <span className="text-xl font-bold text-gray-900 leading-none" data-id="element-654">
                  {intervention.dayNum}
                </span>
                <span className="text-[9px] text-gray-400 uppercase" data-id="element-655">
                  {intervention.month}
                </span>
              </div>

              {/* Intervention Details */}
              <div className="flex-1 min-w-0" data-id="element-656">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-657">
                  <MapPin size={12} className="text-teal-600 flex-shrink-0" data-id="element-658" />
                  <span className="text-sm font-semibold text-navy truncate" data-id="element-659">
                    {intervention.zone}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-660">
                  <span className="flex items-center gap-1" data-id="element-661">
                    <Clock size={11} className="text-gray-400" data-id="element-662" />
                    {intervention.time}
                  </span>
                  <span className="text-gray-300" data-id="element-663">•</span>
                  <span data-id="element-664">{intervention.serviceType}</span>
                </div>
              </div>

              {/* Credits Badge & Arrow */}
              <div className="flex items-center gap-2 flex-shrink-0" data-id="element-665">
                <div className="px-2 py-1 bg-teal-50 text-teal-700 text-xs font-semibold rounded-lg" data-id="element-666">
                  {intervention.credits} cr
                </div>
                <ChevronRight size={16} className="text-gray-300" data-id="element-667" />
              </div>
            </Link>)}
        </div>

        {upcomingInterventions.length === 0 && <div className="p-8 text-center" data-id="element-668">
            <Calendar size={32} className="text-gray-300 mx-auto mb-2" data-id="element-669" />
            <p className="text-sm text-gray-500" data-id="element-670">
              Nessun intervento programmato
            </p>
          </div>}
      </div>

      {/* QUICK ACCESS SHORTCUTS - Host vertical centered layout */}
      <div className="mb-6" data-id="element-671">
        <div className="flex items-center gap-2 mb-3" data-id="element-672">
          <Sparkles size={14} className="text-gray-400" data-id="element-673" />
          <h3 className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-674">
            Accesso rapido
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-675">
          <Link to="/richieste" className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col items-center text-center hover:border-gray-300 transition-colors" data-id="element-676">
            <div className="w-12 h-12 rounded-lg bg-teal-50 flex items-center justify-center mb-3" data-id="element-677">
              <Inbox size={24} className="text-teal-deep" data-id="element-678" />
            </div>
            <div className="text-sm font-medium text-navy" data-id="element-679">Richieste</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-680">3 nuove richieste</div>
          </Link>

          <Link to="/pianificazione" className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col items-center text-center hover:border-gray-300 transition-colors" data-id="element-681">
            <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center mb-3" data-id="element-682">
              <Calendar size={24} className="text-blue-600" data-id="element-683" />
            </div>
            <div className="text-sm font-medium text-navy" data-id="element-684">Pianificazione</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-685">5 programmati</div>
          </Link>

          <Link to="/crediti" className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col items-center text-center hover:border-gray-300 transition-colors" data-id="element-686">
            <div className="w-12 h-12 rounded-lg bg-amber-50 flex items-center justify-center mb-3" data-id="element-687">
              <CreditCard size={24} className="text-amber-600" data-id="element-688" />
            </div>
            <div className="text-sm font-medium text-navy" data-id="element-689">Crediti</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-690">42 disponibili</div>
          </Link>
        </div>
      </div>
    </MobileLayout>;
}